module.exports = __webpack_public_path__ + "img/car1.e7adfa02.png";